import {ormReducer} from "./reducer";

const reducers = {
  orm: ormReducer,
};
export default reducers;
